import { Pipe, PipeTransform } from '@angular/core';
import { importData } from 'src/app/components/route-panel/route/import-stops/import-stops.component';

@Pipe({ name: 'searchByAddress' })
export class SearchByAddressPipe implements PipeTransform {
  transform(stops: importData[], searchText: string, searchType?: string) {
    const searchQuery = searchText.replace(/[ ,]/g, '');

    const filteredStops = stops.filter((stop) => {
      const searchableValue = stop.displayText.replace(/[ ,]/g, '');
      return searchType?.length
        ? searchType.includes(stop?.match?.toLowerCase()) &&
            searchableValue?.toLowerCase().includes(searchQuery?.toLowerCase())
        : searchableValue?.toLowerCase().includes(searchQuery?.toLowerCase());
    });
    return filteredStops?.length
      ? filteredStops
      : [
          {
            row: 'No Match Results Found',
          },
        ];
  }
}
